import { useCallback, useMemo } from "react";
import ILead from "../../interfaces/ILead";
import type IPipedriveOrganization from "../../interfaces/IPipedriveOrganization";
import type IProperty from "../../interfaces/IProperty";
import type { IBase64ScreenshotSet } from "../../services/propertyAiGradeApiService";
import type { IEstimates } from "../usePropertyEstimates";
import usePropertyScreenshots from "../usePropertyScreenshots";
import { buildBoeModelFromLead } from "./boeMappings";
import { useBoeGenerator } from "./useBoeGenerator";

export function useLeadBoeGenerator(lead: ILead, property: IProperty | undefined) {
    const { screenshots, isLoading, isError, fetchScreenshots } = usePropertyScreenshots(property);
    const dataSource = useMemo(() => ({ data: screenshots, isLoading, isError, fetch: fetchScreenshots }), [screenshots, isLoading, isError, fetchScreenshots]);

    const buildModel = useCallback((screenshots: IBase64ScreenshotSet, estimates: IEstimates, initials: string, pipedriveOrganizations: IPipedriveOrganization[]) => {
        if (!property) return null;

        return buildBoeModelFromLead(
            lead,
            property,
            estimates,
            screenshots.mapbox!,
            initials,
            pipedriveOrganizations,
        );
    }, [lead, property]);

    return useBoeGenerator(property, dataSource, buildModel);
}
